var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { lg: 7, md: 9, sm: 12, span: 6, xl: 6, xs: 24 } },
            [
              _c("img", {
                staticStyle: { width: "100%" },
                attrs: { src: "images/anze-product.png" },
              }),
            ]
          ),
          _c(
            "el-col",
            { attrs: { lg: 16, md: 14, sm: 12, span: 18, xl: 18, xs: 24 } },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "16px" } },
                [
                  _c("h2", [_vm._v("前海1-4类雇主险")]),
                  _c("div", { staticStyle: { color: "red" } }, [
                    _vm._v("行业超低价 | 全线上操作 | 可扩展伤残10%"),
                  ]),
                  _c("p", [
                    _vm._v("\n\t\t\t\t\t① 投保简便支持月单\n\t\t\t\t\t"),
                    _c("br"),
                    _vm._v("\n\t\t\t\t\t② 社保用药100%赔付\n\t\t\t\t\t"),
                    _c("br"),
                    _vm._v("\n\t\t\t\t\t③ 3人起保，最高可保100万\n\t\t\t\t\t"),
                    _c("br"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "medium", type: "warning" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleInsure.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("立即投保")]
                  ),
                  _c("br"),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-top": "25px" },
                      attrs: {
                        loading: _vm.isDownLoading,
                        icon: "el-icon-download",
                        size: "medium",
                        type: "text",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleDownLoad.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n\t\t\t\t\t下载前海雇主险职业类别表\n\t\t\t\t")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentStep,
            callback: function ($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "保险详情", name: "0" } },
            [
              _c(
                "el-card",
                [
                  _c(
                    "el-row",
                    {
                      staticStyle: {
                        "margin-bottom": "15px",
                        "margin-left": "10px",
                      },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _vm._v("\n\t\t\t\t\t\t档次：\n\t\t\t\t\t\t"),
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择档次" },
                              on: { change: _vm.onChangePriceRate },
                              model: {
                                value: _vm.priceRate,
                                callback: function ($$v) {
                                  _vm.priceRate = $$v
                                },
                                expression: "priceRate",
                              },
                            },
                            _vm._l(_vm.priceRateList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _vm._v("\n\t\t\t\t\t\t扩展方案：\n\t\t\t\t\t\t"),
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择扩展方案" },
                              on: { change: _vm.onChangeKuozhanRate },
                              model: {
                                value: _vm.kuozhanRate,
                                callback: function ($$v) {
                                  _vm.kuozhanRate = $$v
                                },
                                expression: "kuozhanRate",
                              },
                            },
                            _vm._l(_vm.kuozhanRateList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("avue-crud", {
                    ref: "crud",
                    attrs: {
                      "cell-style": _vm.onCellStyle,
                      data: _vm.dataPlan,
                      option: _vm.optionPlan,
                      "span-method": _vm.spanMethodPlan,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "常见问题", name: "1" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 20 } }, [
                    _c(
                      "ul",
                      _vm._l(_vm.dataQA, function (qa) {
                        return _c(
                          "li",
                          { key: qa.question },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "20px",
                                    "text-align": "center",
                                    "background-color": "MediumPurple",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\tQ\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [_vm._v(_vm._s(qa.question))]
                              ),
                            ]),
                            _c("p"),
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "20px",
                                    "background-color": "MediumSeaGreen",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\tA\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              qa.question === "该保险方案是否可以保高空？"
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "white-space": "pre-wrap",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t本保险方案\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c("span", { staticClass: "red-bold" }, [
                                        _vm._v(
                                          "不承保高处作业时发生的意外事故"
                                        ),
                                      ]),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t，因高空作业导致的任何损失，保险公司不承担赔偿责任。所谓高处作业是指人在一定位置为基准的高处进行的作业。\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c("span", { staticClass: "red-bold" }, [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业。\n\t\t\t\t\t\t\t\t\t"
                                        ),
                                      ]),
                                    ]
                                  )
                                : qa.question === "该保险方案责任范围包括哪些？"
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "white-space": "pre-wrap",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t在保险期间内，被保险人的\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c("span", { staticClass: "red-bold" }, [
                                        _vm._v("雇员"),
                                      ]),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t在受雇过程中从事被保险人的业务工作而遭受意外伤害或罹患国家规定的职业病所致伤残或死亡，符合国务院颁布的《工伤保险条例》规定可认定为工伤的以下情形，依照中华人民共和国法律（不包括港澳台地区，下同）应由被保险人承担的经济赔偿责任，保险人按照本保险合同约定负责赔偿：\n\t\t\t\t\t\t\t\t\t（一）在工作时间和工作场所内，因工作原因受到事故伤害；\n\t\t\t\t\t\t\t\t\t（二）工作时间前后在工作场所内，从事与工作有关的预备性或者收尾性工作受到事故伤害；\n\t\t\t\t\t\t\t\t\t（三）在工作时间和工作场所内，因履行工作职责受到暴力等意外伤害； （四）患职业病；\n\t\t\t\t\t\t\t\t\t（五）因工外出期间，由于工作原因受到伤害或者发生事故下落不明； （六）在上下班途中，\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c("span", { staticClass: "red-bold" }, [
                                        _vm._v("受到非本人主要责任的交通事故"),
                                      ]),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t或者城市轨道交通、客运轮渡、火车事故伤害；\n\t\t\t\t\t\t\t\t\t（七）在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡；\n\t\t\t\t\t\t\t\t\t（八）在抢险救灾等维护国家利益、公共利益活动中受到伤害；\n\t\t\t\t\t\t\t\t\t（九）原在军队服役，因战、因公负伤致残，已取得革命伤残军人证，到用人单位后旧伤复发；\n\t\t\t\t\t\t\t\t\t（十）法律、行政法规规定应当认定为工伤的其他情形。\n\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  )
                                : qa.question ===
                                  "有哪些损失、费用和责任，该保险方案不赔偿？"
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "white-space": "pre-wrap",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t以下损失、费用和责任，该保险方案不赔偿。\n\t\t\t\t\t\t\t\t\t（一）被保险人应该承担的合同责任，但无合同存在时仍然应由被保险人承担的经济赔偿责任不在此限；\n\t\t\t\t\t\t\t\t\t（二）罚款、罚金及惩罚性赔偿； （三）\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c("span", { staticClass: "red-bold" }, [
                                        _vm._v("精神损害赔偿；"),
                                      ]),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t（四）间接损失； （五）除另有约定外，在中华人民共和国境外所发生的雇员的伤残或死亡； （六）\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c("span", { staticClass: "red-bold" }, [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t超出雇员所在地工伤保险诊疗项目目录、工伤保险药品目录、工伤保险住院服务标准的医疗费用；\n\t\t\t\t\t\t\t\t\t"
                                        ),
                                      ]),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t（七）\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c("span", { staticClass: "red-bold" }, [
                                        _vm._v("工伤保险已经支付的费用；"),
                                      ]),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t（八）雇员在中华人民共和国境外（包括港、澳、台地区）发生的人身伤亡；\n\t\t\t\t\t\t\t\t\t（九）被保险人对其承包商的雇员的赔偿责任； （十）\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c("span", { staticClass: "red-bold" }, [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t陪护费、伙食费、营养费、交通费、取暖费、空调费及安装假肢、假牙、假眼和残疾用具等费用；\n\t\t\t\t\t\t\t\t\t"
                                        ),
                                      ]),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t（十一）本保险合同中载明的免赔额。\n\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  )
                                : qa.question === "哪些职业可保？"
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "white-space": "pre-wrap",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t本保单可承保1-4类职业：餐饮业（不含外卖送餐、跑腿代购人员）、旅游业/商业、服务业/物业/家政服务/\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c("span", { staticClass: "red-bold" }, [
                                        _vm._v("室内装修、室内保洁"),
                                      ]),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t、室内电器安装（不含空调）/能源开发利用业/纺织及纺织制品业，具体职业以《前海财险职业类别分类表》为准。\n\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  )
                                : qa.question === "哪些职业不保？"
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "white-space": "pre-wrap",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t本方案拒绝承保职业：农畜渔牧业/木材森林业/矿业采石业/交通运输业/建筑工程业（\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c("span", { staticClass: "red-bold" }, [
                                        _vm._v("不含室内项目"),
                                      ]),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t)/职业运动员/娱乐业/公共事业/家用空调安装/电梯行业/军人/金属冶炼/高压电相关职业/水泥石膏石灰行业/化工制造行业/火药、炸药、烟花业/邮政/快递、窑炉/烟囱建设及拆除、石油天然气开发、危险品/危化品、家具/家私业、船舶/造船业。\n\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "span",
                                { staticStyle: { "white-space": "pre-wrap" } },
                                [_vm._v(_vm._s(qa.answer))]
                              ),
                            ]),
                            _c("el-divider"),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "投保须知", name: "2" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c("h3", [_vm._v("保险条款及须知")]),
                      _c("p", { staticStyle: { "line-height": "32px" } }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t1. 本保险适用以下保险条款：\n\t\t\t\t\t\t"
                        ),
                        _c("span", [
                          _c(
                            "a",
                            {
                              staticStyle: { color: "DodgerBlue" },
                              attrs: {
                                href: "https://mbtest.meibaokeji.com.cn/employer/static/2022images/pdf/qianhai.pdf",
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t新疆前海联合财产保险股份有限公司雇主责任保险条款\n\t\t\t\t\t\t\t"
                              ),
                            ]
                          ),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t，备案编号为：(前海财险)(备-责任保险)【2019】(主) 014号\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t2、本保险由新疆前海联合财产保险股份有限公司承保，承保区域为全国范围（港澳台除外）。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t3、保险公司全国统一的客户服务及投诉方式详见链接：\n\t\t\t\t\t\t"
                        ),
                        _c("span", [
                          _c(
                            "a",
                            {
                              staticStyle: { color: "DodgerBlue" },
                              attrs: {
                                href: "https://www.qhins.com/cms/statics/complaintProcess.html",
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t全国统一的客户服务及投诉方式\n\t\t\t\t\t\t\t"
                              ),
                            ]
                          ),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t4、在投保本保险前请您认真阅读《保险条款》，了解本保险的保险责任及责任免除，尤其是对其中免除保险人责任的条款(包括但不限于责任免除、投保人被保险人义务等)。在充分理解并接受上述内容的基础上，同意以此作为订立保险合同的依据。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t5、在投保本保险时您应如实填写各项投保信息以履行相应的如实告知义务，若故意或者因重大过失未履行如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同；故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费；因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t6、本保险合同以电子保单形式提供。根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，与纸质合同具有同样的法律效力。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t7、本保险根据投保单位的需求提供电子发票或纸质专票。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t8、本保险由博维保险经纪有限公司面向全国销售并提供服务，如有其他疑问，请在投保前联系客服热线400-180-1616进行咨询与确认。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("el-divider"),
                      _c("h3", [_vm._v("特别约定")]),
                      _c("p", { staticStyle: { "line-height": "32px" } }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t1、鉴于被保险人营业性质包括\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t个体工商户等形式，本保险所指的工作人员，包括但不限于被保险人的长期雇佣人员、临时雇佣人员等\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t。被保险人雇员年龄范围为16周岁-65周岁（\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v("截至65岁生日当天"),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t），不在本年龄段范围内，所发生的事故，保险人均不承担保险责任。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t2、被保险人雇员遭受意外伤害时，实际从事的工作危险程度高于投保人明确告知保险人的工作类型的，如仍在保险人承保职业类别范围内，则保险人对按保单约定的应承担的保险责任，绝对免赔率为损失金额的20%，\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v("并且"),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t，投保人需补交对应的保费；如非在承保职业类别范围内，则不予赔付。若投保职业对应的保费，大于或等于被保险人实际职业类别对应的保费，保险人不得以投保职业有误而拒赔或者减少承担赔偿责任。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t3、本保单记名投保，本项目所有保单可加人（不足1个月的按1个月收费），不可减人。保险期限1-3个月的保单不可换人，保险期限超过3个月的保单可以换人。换人规则：原1-2类职业人员可替换为新的1-2类职业人员；原3类职业人员可替换为新的3类职业人员；原4类职业人员可替换为新的4类职业人员；不同职业人员之间不可互换。已发生理赔的人员不可以被更换。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t4、本保单雇员必须与被保险人存在实际雇佣关系，否则，保险人有权拒绝赔偿。本保单不承保承揽关系。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t5、被保险人雇员遭遇保险事故导致身故，保险人按工伤赔偿标准核算身故赔偿金，在不超过保单列明的每人死亡赔偿限额内赔付。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t6、①\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v("若不扩展伤残赔偿比例十级标准"),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t，如被保险人雇员遭遇保险事故导致伤残，每人可从保险人获得的伤残赔偿金限额=每人伤残赔偿限额*伤残等级对应的赔付比例。本保单按国家社保《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）进行伤残等级鉴定，一级到十级伤残的比例分别为：100%，80%，70%，60%，50%，40%，30%，\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v("20%，10%，5%。"),
                        ]),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t②\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v("若扩展伤残赔偿比例十级标准"),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t，如被保险人雇员遭遇保险事故导致伤残，每人可从保险人获得的伤残赔偿金限额=每人伤残赔偿限额*伤残等级对应的赔付比例。本保单按国家社保《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）进行伤残等级鉴定，一级到十级伤残的比例分别为：100%，80%，70%，60%，50%，40%，30%，\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v("25%，15%，10%。"),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\n\t\t\t\t\t\t7、医疗费用适用独立的赔偿限额，不包含在死亡、伤残赔偿限额之内。按社保内用药100%赔付。按照实际指定就诊医院所在地的（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准赔付。被保险人均应在二级以上（含二级）公立医院或保险人认可的医疗机构就诊。如因紧急抢救无法前往本保单指定就诊医院，须在保险事故发生后72小时内转入本保单指定就诊医院。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t但以下地区或指定医疗机构发生的费用不在赔偿范围内：\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t①以下地区的所有医疗机构发生的费用不在赔偿范围内:\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t北京平谷区、密云县、怀柔区；\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "河北省三河市、沧州市、河北青龙县、廊坊市；天津市"
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t；辽宁铁岭；江苏徐州、南通、\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v("连云港、常州"),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t；山东德州、禹城市、临沂、山东金乡县；河南信阳市；湖北黄冈市、荆州市；四川宜宾市；\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t②以下医疗机构发生的费用不在赔偿范围内：\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t四川省雅安市雨城区人民医院、四川省雅安市第二人民医院、河南省新乡市中医院、吉林省四平市第一人民医院、吉林省四平市梨树县第一人民医院、吉林省四平市中医医院、中国医科大学附属盛京医院、山东省莱州市人民医院、山东齐鲁医院、莱州市中医院、莱州市郭家店中心卫医院、山东滨州市中心医院。河北省保定市第一医院.\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t以上地区的医院和指定的医院均不在保险公司认可医院范围内，即上述的医疗机构的发票保险公司不予理赔。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\n\t\t\t\t\t\t8、误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算包含住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且一旦确定伤残程度后即刻停止误工费的计算。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t9、\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v("本保单不承保高处作业时发生的意外事故"),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t，因高空作业导致的任何损失，保险公司不承担赔偿责任。所谓高处作业是指人在一定位置为基准的高处进行的作业。国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t10、被保险人雇员如果有工伤保险的，则由工伤保险先行赔付，此保单再补充赔付。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t11、在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡,保险人承担赔偿责任，赔款限额=每人身故赔偿限额*20%，且该赔偿金额包含在身故赔偿限额范围内。但雇员因\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v("职业病以外的"),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t疾病、分娩、流产原因\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v("以及因上述原因接受医疗、诊治"),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t不在保单赔偿责任范围内。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t12、在上下班途中，受到非本人主要责任的交通事故或者城市轨道交通、客运轮渡、火车事故伤害的，属于保险责任。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t13、\n\t\t\t\t\t\t"),
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t本保单可承保1-4类职业：餐饮业（不含外卖送餐、跑腿代购人员）、旅游业/商业、服务业/\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("物业/家政服务/室内装修、室内保洁"),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t、室内电器安装（不含空调）/\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("能源开发利用业"),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t/纺织及纺织制品业 ，具体职业以《前海财险职业类别分类表》为准。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t14、被保险人拒保职业范围：农畜渔牧业/木材森林业/矿业采石业/交通运输业/建筑工程业（\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v("不含室内项目"),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t）/职业运动员/娱乐业/公共事业/家用空调安装/电梯行业/军人/金属冶炼/高压电相关职业/水泥石膏石灰行业/化工制造行业/火药、炸药、烟花业/邮政/快递、窑炉/烟囱建设及拆除、石油天然气开发、危险品/危化品、家具/家私业、船舶/造船业。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t15、\n\t\t\t\t\t\t"),
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t被保险人的雇员无有效驾驶证驾驶机动车或无国家有关部门核发的有效资格证书而使用各种专用机械、\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("特种设备"),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t、特种车辆或类似设备装置发生意外事故导致伤害，\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("不在保单赔偿范围内。"),
                          ]),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t16、一旦发生保险事故，被保险人应在事故发生48小时内及时通过保险公司服务热线4008110110，并书面说明事故发生的原因、经过和损失情况；因延迟报案影响保险人查勘、定损的，保险人对无法核实部分不承担任何赔偿责任。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t17、\n\t\t\t\t\t\t"),
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t本保单禁止承保以下地区业务：\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t黑龙江、辽宁、吉林、新疆、西藏、青海、宁夏、甘肃、天津、河北、山东荣成、山东青岛、北京平谷区、北京密云区\n\t\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t。对于在被保险人实际用人所在地在以上地区的，保险公司不承担赔偿责任。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t18、\n\t\t\t\t\t\t"),
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v(
                            "法律费用每次事故赔偿限额10万，累计赔偿限额10万。"
                          ),
                        ]),
                        _c("br"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }